import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EmailServiceService } from './service/email-service.service';
@Component({
	selector: 'app-email-template',
	templateUrl: './email-template.page.html',
	styleUrls: ['./email-template.page.scss'],
})
export class EmailTemplatePage implements OnInit {
	emailTemplateList$: Observable<any> = new Observable();

	constructor(
		private emailTemplateService: EmailServiceService,
		private router: Router,
	) {}

	ngOnInit() {
		this.emailTemplateService.loadinit().subscribe();
		this.emailTemplateService.loadapi().subscribe();
		this.emailTemplateList$ = this.emailTemplateService.fetchdata();
	}
	createEmailTemplate() {
		//
	}
	editEmailTemplate(id: any) {
		this.router.navigate([`/app/serverless/email-template/get-email/` + id]);
	}
	deleteEmailTemplate(id: any) {
		//
	}
}
